/* eslint-disable @typescript-eslint/prefer-promise-reject-errors */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/* eslint-disable @typescript-eslint/no-unsafe-assignment*/
import Axios from 'axios';
import type { InternalAxiosRequestConfig } from 'axios';
function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const session = localStorage.getItem('sessionInfo');
  const sessionObject = session
    ? (JSON.parse(session) as {
        username: string;
        sessionToken: string;
      })
    : undefined;
  if (sessionObject) {
    config.headers.Authorization = `Bearer ${sessionObject.sessionToken}`;
  }
  config.withCredentials = true;
  return config;
}
export const api = Axios.create({
  baseURL: import.meta.env.VITE_ADMIN_API_URL,
});
api.interceptors.request.use(authRequestInterceptor);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      alert(
        'Your session has expired. You will be redirected to the login screen.',
      );
      if (!currentPath.includes('/login') && currentPath !== '/logout') {
        window.location.href = `/login?from=${encodeURIComponent(currentPath)}`;
      }
    }
    return Promise.reject(error);
  },
);

export const interceptorAddGameAndSandbox = (game: string, sandbox: string) =>
  api.interceptors.request.use((config) => {
    config.params = {
      sandbox_code: sandbox,
      game_code: game,
      ...config.params,
    };
    return config;
  });
